<template>
  <div>
    <wg-modal :width="'auto'" :simple="true">
      <div class="wg-row" style="flex-direction:column;align-items:center;justify-content:center;" slot="body">
        <vue-simple-spinner size="medium" :line-fg-color="appColor"></vue-simple-spinner>
        <div v-if="text" class="com-anm22-app-text-xl" style="margin-top:10px;">
          {{ text }}
        </div>
      </div>
    </wg-modal>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import { mapState } from 'vuex';

export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      appColor: state => state.config.appColor || 'rgb(136, 237, 124)'
    })
  },
  components: {
    'vue-simple-spinner': Spinner
  }
};
</script>

<style lang="scss" scoped>
.spinner {
  align-items: center;
  justify-content: center;
  min-height: 100%;
  margin-left: 10px;
}
</style>
